module.exports = __webpack_public_path__ + "static/img/menu-ml-light.046392c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-ml-light.png
// module id = GRS3
// module chunks = 2